import axios from 'axios'
import store from '../store';
// import NProgress from 'nprogress'
const apiClient = axios.create({
    baseURL: process.env.VUE_APP_PRICING_API_URL,
    withCredentials: true, // This is the default
})
apiClient.interceptors.request.use(config => { // Called on request
    store.state.layout.isLoading = true;
    return config
})
apiClient.interceptors.response.use(response => { // Called on response
    store.state.layout.isLoading = false;
    return response
})
apiClient.defaults.headers.common['x-requested-with'] = 'xmlhttprequest';

export default apiClient